import { Box, Button, Flex, Grid, Image, Text } from "@mantine/core";
import useStyles from "./style";
import LinePatternSvg from "../../components/Svgs/LinePatternSvg";
import { useNavigate } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";

const SkypointCheckEmail = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Grid className={classes.container}>
      <Grid.Col span={12} md={6} className={classes.leftCol}>
        <Flex direction="column" align="center" className={classes.leftContent}>
          <Box className={classes.LogoBar} pr={14} pb={20} h={76} w="100%">
            <Image
              src="/assets/images/skypoint-logo2.png"
              height={44}
              width={144}
            />
          </Box>
          <Flex
            direction="column"
            align="center"
            justify="center"
            className={classes.contentWrapper}
          >
            <Flex
              align="center"
              justify="center"
              className={classes.emailIconBox}
            >
              <HiOutlineMail />
            </Flex>
            <Text fz={20} fw={600} ff="Inter" color="#171717">
              Email verification
            </Text>
            <Text
              fz={16}
              fw={400}
              ff="Inter"
              mt={12}
              mb={31}
              align="center"
              color="#737373"
            >
              A link has been send to the mail provided. Kindly clink the link
              to verify your Email
            </Text>
            <Button className={classes.loginBtn} onClick={() => navigate("/skypoint-login")}>Login</Button>
          </Flex>
        </Flex>
      </Grid.Col>
      <Grid.Col span={12} md={6} className={classes.rightCol}>
        <Flex
          className={classes.rightContent}
          align="center"
          justify="flex-end"
        >
          <Box className={classes.linePattern1Parent}>
            <LinePatternSvg />
          </Box>
          <img
            src="/assets/images/skypoint-invoice.png"
            alt=""
            className={classes.invoiceImg}
          />
          <Box className={classes.linePattern2Parent}>
            <LinePatternSvg />
          </Box>
        </Flex>
      </Grid.Col>
    </Grid>
  );
};

export default SkypointCheckEmail;
